// extracted by mini-css-extract-plugin
export default {"historyTab":"PatientTab_historyTab__m5prY"};